import { Field, Float, Int } from '@nestjs/graphql'
import { PenNameFollowerDto } from './follower.model.dto'
import { BaseModelDto } from '../base/baseModel.dto'
import { ObjectType } from '@nestjs/graphql'

@ObjectType()
export class PenNameDto extends BaseModelDto {
  @Field(type => String)
  name!: string

  @Field(type => String)
  firstName!: string

  @Field(type => String, { nullable: true })
  lastName!: string

  @Field(t => [PenNameFollowerDto], { nullable: true })
  followers?: PenNameFollowerDto[]

  @Field({ nullable: true })
  bio?: string

  @Field({ nullable: true })
  image?: string

  @Field({ nullable: true })
  facebookLink?: string

  @Field({ nullable: true })
  bookbubLink?: string

  @Field({ nullable: true })
  twitterLink?: string

  @Field({ nullable: true })
  instagramLink?: string

  @Field({ nullable: true })
  websiteLink?: string

  @Field({ nullable: true })
  newsletterLink?: string

  @Field({ nullable: true })
  tiktokLink?: string

  @Field({ nullable: true })
  amazonLink?: string

  @Field({ nullable: true })
  goodreadsLink?: string

  @Field(t => Int, { nullable: true })
  followerCount?: number

  @Field(type => Float, { nullable: true })
  averageRating?: number

  @Field(type => Int, { nullable: true })
  reviewCount?: number

  @Field()
  isDraft!: boolean
}
